import type { RouteDefinition } from '@polestar/shared-front-myorder';
import { config } from '~root/src/config';

const PREFIX = `/:locale/${config.application.namespace}`;

/**
 * Array of route definition object
 * Each object will be map to react-router <Route /> component and respect the following shape
 *
 * - name (string) : name of the route, internal reference used to generate a path for a given route
 * - path (string) : uri fragment, can contain variables in react-router's fashion (e.g. /:locale/something/:id)
 * - exact (boolean) : wether to stricly match path or allow sub-routes (@see react-router)
 * - view (string) : name of the view component to render
 * - private (boolean) : wether the route should be accessible publicly or not
 * - sitemap (object) : public sitemap.xml informations (if set to undefined, will be ignored by the sitemap and not indexed)
 */
export const routes = <RouteDefinition[]>[
  {
    name: 'extras',
    path: `${PREFIX}/:orderId/extras`,
    view: 'ExtrasView',
    private: true
  },
  {
    name: 'delivered',
    path: `${PREFIX}/:orderId/delivered`,
    view: 'DeliveredView',
    private: true
  },
  {
    name: 'orders',
    path: `${PREFIX}/*`,
    view: 'OrdersView',
    private: true
  }
];
